export default __webpack_public_path__ + "static/media/ERAnewlogo2.11f202d4.png";